import { useEffect, useState } from 'react';

/**
 * The current epoch ms, re-rendered every `intervalMs`. Relative-time labels
 * ("42s ago") need this: without a tick they freeze at the value they had when
 * the row last rendered, which is exactly the kind of silently-stale display
 * the age is there to expose.
 */
export function useNow(intervalMs: number): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);
  return now;
}
